import type { ReactElement } from "react";

import type { TIconProps } from "../types";

// NOTE: Smartsheet's official brand mark. Rendered monochrome (tinted to
// --primary) to match the rest of the integration icon set; the brand navy
// (#0e2947) is swapped for the primary tint.
export const Smartsheet = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1238 1514"
    {...props}
  >
    <path
      d="m615 1204c0 0 263.4-657.8 622.9-1096.3 0 180.9 0 539.9 0 811.3 0 150.7-5.5 274-11 328.8-5.5 54.9-19.2 90.5-41.1 96-16.5 2.7-43.9-2.8-96.1-63.1-46.6-54.8-93.3-156.2-93.3-156.2l-5.5-11-8.2 8.3c-2.7 0-145.4 142.5-515.9 274-208.5 74-411.5 109.7-466.4 117.9 5.5-21.9 16.4-76.8 16.4-150.8 0-95.9 0-1246.9 0-1362.1h1215.6c-197.6 186.4-441.8 466-589.9 794.8-16.5-35.6-123.5-274-258-271.3-85 2.8-150.9 93.2-150.9 93.2 208.6-2.7 381.4 586.5 381.4 586.5z"
      fill="hsl(from hsl(205 86% 42%) h s 50%)"
    />
  </svg>
);
